module.exports = __webpack_public_path__ + "static/media/ic-contact-phone.2f0c92d5.svg";